/* Kōbu scroll-scrubbed powder demo.
   Pure function of scroll position, so scrolling up reverses it smoothly.
   No dependencies. Skips entirely when the visitor prefers reduced motion. */
(function () {
  var clamp = function (v, a, b) {
    a = a === undefined ? 0 : a;
    b = b === undefined ? 1 : b;
    return Math.min(b, Math.max(a, v));
  };
  var smooth = function (t) { return t * t * (3 - 2 * t); };
  var range = function (p, a, b) { return smooth(clamp((p - a) / (b - a), 0, 1)); };
  var rand = function (i, salt) {
    var x = Math.sin(i * 127.1 + salt * 311.7) * 43758.5453;
    return x - Math.floor(x);
  };

  function init(root) {
    if (root.dataset.kobuInit === "1") return;
    root.dataset.kobuInit = "1";
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var canvas = root.querySelector(".kobu-demo__canvas");
    var titleEl = root.querySelector("[data-kobu-step-title]");
    var bodyEl = root.querySelector("[data-kobu-step-body]");
    var countEl = root.querySelector("[data-kobu-step-count]");
    var dots = root.querySelectorAll(".kobu-demo__dot");
    if (!canvas) return;
    var ctx = canvas.getContext("2d");
    if (!ctx) return;
    var steps = [];
    try { steps = JSON.parse(root.getAttribute("data-steps") || "[]"); } catch (e) { steps = []; }
    var tint = (root.getAttribute("data-tint") || "240,214,90").split(",").map(Number);

    var img = new Image();
    img.src = root.getAttribute("data-stick") || "";

    var w = 0, h = 0, dpr = 1, mobile = false, progress = 0, raf = 0, lastStep = -1;

    function resize() {
      var rect = canvas.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      mobile = rect.width < 700;
      w = rect.width; h = rect.height;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function draw() {
      var p = progress;
      ctx.clearRect(0, 0, w, h);
      var scale = Math.min(w / 720, h / 620);
      var cx = w / 2 - scale * 110;
      var glassW = 240 * scale, glassH = 330 * scale;
      var glassTop = h * 0.42, glassBottom = glassTop + glassH;

      // The sachet opens at its lower edge, so keep that edge over the glass
      // while scrubbing the body from horizontal into its pouring position.
      var rotationP = range(p, 0, 0.48);
      var tiltP = range(p, 0.18, 0.48);
      // Begin pouring as soon as the opening is revealed, rather than waiting
      // for the stick to finish rotating upright.
      var pourStart = 0.18;
      var liftP = range(p, 0.62, 0.8);
      var stickH = 400 * scale, stickW = stickH * 0.19;
      // Add a subtle 10° bias to both ends of the turn for a more natural pose.
      // In this canvas coordinate system that is the open-end-safe equivalent
      // of the requested 190° → 100° stick-axis rotation.
      var startAngle = 100 * Math.PI / 180;
      var endAngle = 10 * Math.PI / 180;
      var angle = startAngle + (endAngle - startAngle) * rotationP;
      var mouthX = cx, mouthY = glassTop - (58 + liftP * 60) * scale;
      var stickX = mouthX + Math.sin(angle) * (stickH / 2);
      var stickY = mouthY - Math.cos(angle) * (stickH / 2);

      ctx.save();
      ctx.translate(stickX, stickY);
      ctx.rotate(angle);
      if (img.complete && img.naturalWidth) {
        ctx.globalCompositeOperation = "multiply";
        ctx.drawImage(img, -stickW / 2, -stickH / 2, stickW, stickH);
      } else {
        ctx.fillStyle = "#e7dd6a";
        ctx.fillRect(-stickW / 2, -stickH / 2, stickW, stickH);
      }
      ctx.restore();

      if (rotationP > 0.25) {
        ctx.save();
        ctx.translate(stickX, stickY);
        ctx.rotate(angle);
        ctx.globalCompositeOperation = "destination-out";
        ctx.globalAlpha = range(rotationP, 0.25, 0.48);
        ctx.beginPath();
        var cutTop = -stickH / 2;
        ctx.moveTo(-stickW, cutTop + stickH * 0.98);
        ctx.lineTo(stickW, cutTop + stickH * 0.88);
        ctx.lineTo(stickW, cutTop + stickH);
        ctx.lineTo(-stickW, cutTop + stickH);
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      }

      var topHalf = glassW / 2, botHalf = glassW / 2 - 16 * scale;
      function glassPath() {
        ctx.beginPath();
        ctx.moveTo(cx - topHalf, glassTop);
        ctx.lineTo(cx - botHalf, glassBottom - 14 * scale);
        ctx.quadraticCurveTo(cx - botHalf, glassBottom, cx - botHalf + 14 * scale, glassBottom);
        ctx.lineTo(cx + botHalf - 14 * scale, glassBottom);
        ctx.quadraticCurveTo(cx + botHalf, glassBottom, cx + botHalf, glassBottom - 14 * scale);
        ctx.lineTo(cx + topHalf, glassTop);
        ctx.closePath();
      }

      var waterTop = glassTop + glassH * 0.18;
      var mixP = range(p, 0.5, 0.92);
      ctx.save();
      glassPath();
      ctx.clip();
      var grad = ctx.createLinearGradient(0, waterTop, 0, glassBottom);
      grad.addColorStop(0, "rgba(" + tint[0] + "," + tint[1] + "," + tint[2] + "," + (0.05 + mixP * 0.5) + ")");
      grad.addColorStop(1, "rgba(" + tint[0] + "," + tint[1] + "," + tint[2] + "," + (0.18 + mixP * 0.55) + ")");
      ctx.fillStyle = "rgba(226,238,242,0.75)";
      ctx.fillRect(cx - topHalf, waterTop, glassW, glassBottom - waterTop);
      ctx.fillStyle = grad;
      ctx.fillRect(cx - topHalf, waterTop, glassW, glassBottom - waterTop);

      var swirl = Math.sin(p * 24) * (1 - mixP) * range(p, 0.45, 0.7);
      for (var i = 0; i < 5; i++) {
        var y = waterTop + ((i + 0.5) / 5) * (glassBottom - waterTop);
        ctx.globalAlpha = 0.25 * (1 - mixP) * range(p, 0.42, 0.62);
        ctx.strokeStyle = "rgba(" + tint[0] + "," + tint[1] + "," + tint[2] + ",1)";
        ctx.lineWidth = 10 * scale;
        ctx.beginPath();
        ctx.moveTo(cx - topHalf, y);
        ctx.bezierCurveTo(cx - topHalf / 2, y + swirl * 26 * scale, cx + topHalf / 2, y - swirl * 26 * scale, cx + topHalf, y);
        ctx.stroke();
      }
      ctx.globalAlpha = 1;

      ctx.restore();

      // Draw the stream after the glass fill so it remains visible between
      // the packet and the rim, then continues into the drink.
      var count = mobile ? 90 : 220;
      ctx.fillStyle = "rgba(" + tint[0] + "," + tint[1] + "," + tint[2] + ",0.95)";
      for (var k = 0; k < count; k++) {
        var delay = rand(k, 1) * 0.55;
        var speed = 0.28 + rand(k, 2) * 0.24;
        var t = clamp((p - pourStart - delay * 0.32) / speed, 0, 1);
        if (t <= 0 || t >= 1) continue;
        var spread = (rand(k, 3) - 0.5) * 30 * scale;
        var x = mouthX + spread * (0.25 + t) + Math.sin(t * 6 + k) * 3 * scale;
        var targetY = waterTop + rand(k, 5) * (glassBottom - waterTop) * 0.55;
        var py = mouthY + (targetY - mouthY) * (t * t);
        var r = (0.9 + rand(k, 4) * 1.9) * scale;
        ctx.globalAlpha = py > waterTop ? 0.7 * (1 - (py - waterTop) / (glassBottom - waterTop)) : 0.95;
        ctx.beginPath();
        ctx.arc(x, py, r, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;

      glassPath();
      ctx.strokeStyle = "rgba(35,31,32,0.28)";
      ctx.lineWidth = 2.5 * scale;
      ctx.stroke();
      ctx.save();
      glassPath();
      ctx.clip();
      ctx.fillStyle = "rgba(255,255,255,0.5)";
      ctx.fillRect(cx - topHalf + 12 * scale, glassTop + 8 * scale, 10 * scale, glassH - 30 * scale);
      ctx.restore();

      ctx.beginPath();
      ctx.moveTo(cx - topHalf + 4 * scale, waterTop);
      ctx.lineTo(cx + topHalf - 4 * scale, waterTop);
      ctx.strokeStyle = "rgba(35,31,32,0.15)";
      ctx.lineWidth = 2 * scale;
      ctx.stroke();
    }

    function onScroll() {
      var rect = root.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      progress = clamp(total > 0 ? -rect.top / total : 0, 0, 1);
      if (steps.length) {
        var idx = Math.min(steps.length - 1, Math.floor(progress * steps.length));
        if (idx !== lastStep) {
          lastStep = idx;
          if (titleEl) titleEl.textContent = steps[idx].title;
          if (bodyEl) bodyEl.textContent = steps[idx].body;
          if (countEl) countEl.textContent = "Step " + (idx + 1) + " / " + steps.length;
          for (var d = 0; d < dots.length; d++) dots[d].classList.toggle("is-active", d === idx);
        }
      }
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(draw);
    }

    img.onload = draw;
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () { resize(); onScroll(); });
    resize();
    onScroll();
  }

  function boot() {
    document.querySelectorAll("[data-kobu-demo]").forEach(init);
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
